// extracted by mini-css-extract-plugin
module.exports = {"card":"styles__card___5Ya5f","title":"styles__title___2nwot","close":"styles__close___2hLRO","input":"styles__input___9QSz8"};